const BASE_URL = process.env.REACT_APP_SERVER_URL;
const S3_PUBLIC_DOMAIN = process.env.REACT_APP_S3_PUBLIC_DOMAIN;

export const __constants = {
    baseurl: BASE_URL,
    timezone: "Europe/Madrid",
    images: S3_PUBLIC_DOMAIN,
    authToken: "nonaAuthToken",
    listingLimit: 10,
    defaulDialCode: "91"
};

export const __permissions = [
    "Seeker",
    "HouseKeeper",
    "BabySitter",
    "AppManagement",
    "RoleManagement",
    "AccountSetting"
];

export const __roles = {
    seeker: "Seeker",
    houseKeeper: "HouseKeeper",
    babySitter: "BabySitter"
};

export const __permissionsObj = {
    Dashboard: "Dashboard",
    Seeker: "Seeker",
    HouseKeeper: "HouseKeeper",
    BabySitter: "BabySitter",
    bookingManagement: "BookingManagement",
    AppManagement: "AppManagement",
    RoleManagement: "RoleManagement",
    AccountSettin: "AccountSetting",
    reviews : "Review"
};


export const __snackBarText = {
    fieldEror: "Please, Fill all the Details.",
    internalServerError: "Internal Server Error",
    unKnownError: "Unknown Error Occured",
    noDataFound: "No Data Found",
    email : "Please enter email.",
    password : "Please enter password."
}

export const __snackBarSeverity = {
    error: "error",
    info: "info",
    success: "success",
    warning: "warning"
}

export const __jobStatus = {
  posted: 101,
  cancelled: 102,
  hired: 103,
  completed: 104,
  finalized: 105,
  expired: 106,
  declined: 107,
  refundByNona:108,
  partiallyRefundByNona:109,
}

export const __applicationStatus = {
    applied: 201,
    accepted: 202,
    declined: 203,
    cancelled: 204,
    hired: 205,
    completed: 206,
    finalized: 207,
    expired:208,
    refundByNona:209,
    partiallyRefundByNona:210,
}

export const __applicationStatusDisplay = {
    201: "Applied",
    202: "Invited",
    203: "Declined",
    204: "Cancelled",
    205: "Hired",
    206: "Completed",
    207: "Finalized",
    208: "Expired",
    209: "refunded",
    210: "partiallyRefunded",
  }
  

// For backward compatibility and display purposes
export const __jobStatusDisplay = {
  101: "Posted",
  102: "Cancelled",
  103: "Hired",
  104: "Completed",
  105: "Finalized",
  106: "Expired",
  107: "Declined",
  108: "refunded",
  109: "partiallyRefunded",

}

export const __legalDocumentType = {
    privacyPolicy: 'PrivacyPolicy',
    termsCondition: 'TermsConditions',
    disclaimer: 'Disclaimer',
    cancelPolicy: 'CancelPolicy'
}

export const _invoiceStatusDsiplay = {
    301: "Pending",
    302: "Cancelled",
    303: "Awaiting Payment",
    304: "Hold",
    305: "Declined",
    306: "Modified",
    307: "Finalized",
    308: "Disputed",
};